import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { string, func, bool } from 'prop-types'
import MdLocalSee from 'react-icons/lib/md/local-see'
import { P, Option } from '../styles/option'
import { handleCyclorama } from '../../../../../store/Actions/UiActions'
import { cycloramaLoading } from '../../../../../store/Actions/CycloramaActions'

class CycloramaButton extends PureComponent {
  handleOpenCyclorama = () => {
    if (!this.props.cycloramaShow) {
      this.props.cycloramaLoading(true)
      this.props.handleCyclorama(true)
    } else {
      this.props.handleCyclorama(!this.props.cycloramaShow)
    }
  }
  render() {
    return (
      <Option
        onClick={() => this.props.online && this.handleOpenCyclorama()}
        title={`Latest Panoramic Image of ${
          this.props.address
        }. Note: This image is more frequently updated than streetview.`}
      >
        <MdLocalSee color={this.props.iconColor} />
        <P theme={this.props.theme}>Cyclorama</P>
      </Option>
    )
  }
}

CycloramaButton.propTypes = {
  theme: string.isRequired,
  handleCyclorama: func.isRequired,
  cycloramaLoading: func.isRequired,
  iconColor: string.isRequired,
  cycloramaShow: bool.isRequired,
  online: bool.isRequired,
}

const mapStateToProps = ({ spi, ui, signsState }) => ({
  theme: spi.theme,
  iconColor: ui.cycloramaShow ? 'green' : spi.theme,
  cycloramaShow: ui.cycloramaShow,
  online: spi.online,
  address: signsState.address,
})

const mapDispatchToProps = dispatch => ({
  handleCyclorama: value => dispatch(handleCyclorama(value)),
  cycloramaLoading: value => dispatch(cycloramaLoading(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CycloramaButton)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/OptionsButtons/CycloramaButton/index.jsx